import { derived, writable } from 'svelte/store';
import { asyncDerivedConsistent } from './utils';
export const files = writable();
export const settings = writable({
    freezeDeps: true,
    freezeDevDeps: true,
    freezeOverrides: true,
    freezePeerDeps: false,
    showOriginal: false,
});
export const areFilesSet = derived(files, ($files) => !!$files);
export const initialContent = asyncDerivedConsistent(files, async (files) => {
    if (!files.packageJson) {
        return;
    }
    const content = JSON.parse(await files.packageJson.text());
    return JSON.stringify(content, null, 2);
});
export const fixedContent = asyncDerivedConsistent([files, settings], async ([files, settings]) => {
    if (!files) {
        return;
    }
    let packageJsonContent;
    let packageLockJsonContent;
    try {
        packageJsonContent = JSON.parse(await files.packageJson.text());
    }
    catch (e) {
        alert('Invalid JSON syntax in package.json: ' + e);
    }
    try {
        packageLockJsonContent = JSON.parse(await files.packageLockJson.text());
    }
    catch (e) {
        alert('Invalid JSON syntax in package-lock.json: ' + e);
    }
    const fixedVersionByPackageName = buildFixedVersionByPackageName(packageLockJsonContent);
    [
        settings.freezeDeps ? 'dependencies' : null,
        settings.freezeDevDeps ? 'devDependencies' : null,
        settings.freezeOverrides ? 'overrides' : null,
        settings.freezePeerDeps ? 'peerDependencies' : null,
    ]
        .filter(Boolean)
        .forEach((property) => {
        if (!packageJsonContent[property]) {
            return;
        }
        packageJsonContent[property] = getFixedVersion(packageJsonContent[property], fixedVersionByPackageName);
    });
    return JSON.stringify(packageJsonContent, null, 2);
});
const buildFixedVersionByPackageName = (packageLockJsonContent) => {
    const packageLockVersions = new Map();
    // lockfileVersion 2 and 3 (preferred)
    if (packageLockJsonContent.packages) {
        Object.entries(packageLockJsonContent.packages).forEach(([packageName, packageInfo]) => {
            if (packageName === '') {
                return;
            }
            packageLockVersions.set(packageName.replace('node_modules/', ''), packageInfo.version);
        });
    }
    // lockfileVersion 1 and 2
    else if (packageLockJsonContent.dependencies) {
        Object.entries(packageLockJsonContent.dependencies).forEach(([packageName, packageInfo]) => packageLockVersions.set(packageName, packageInfo.version));
    }
    else {
        alert('Unsupported package-lock.json file format');
    }
    return packageLockVersions;
};
const getFixedVersion = (unfixedVersionByPackageName, fixedVersionByPackageName) => {
    if (!unfixedVersionByPackageName) {
        return null;
    }
    const versions = new Map();
    Object.keys(unfixedVersionByPackageName).forEach((packageName) => versions.set(packageName, fixedVersionByPackageName.get(packageName) || unfixedVersionByPackageName[packageName]));
    return Object.fromEntries(versions);
};
